import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function ProtectedRoute({ children }) {
  const { accessToken, mustChangePassword } = useSelector((s) => s.auth);
  const location = useLocation();
  const isChangePasswordPage = location.pathname === '/dashboard/change-password';

  if (!accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (mustChangePassword && !isChangePasswordPage) {
    return <Navigate to="/dashboard/change-password" replace />;
  }
  return children;
}
